var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "button",
      {
        staticClass: "btn-outline btn-tertiary",
        staticStyle: { "font-weight": "bold" },
        on: {
          click: function ($event) {
            return _vm.openModal()
          },
        },
      },
      [
        _c("i", { staticClass: "fa-light fa-database" }),
        _vm._v(" Allocate VIBAN\n  "),
      ]
    ),
    _vm._v(" "),
    _vm.isModalOpen
      ? _c("div", { staticClass: "modal-container" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("h1", [
              _vm._v("Allocate VIBAN"),
              _c("i", {
                staticClass: "fa-regular fa-xmark",
                on: {
                  click: function ($event) {
                    return _vm.closeModal()
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("span", [_vm._v("Enter a client number to allocate a VIBAN")]),
            _vm._v(" "),
            _vm.allocateResult.length == 0
              ? _c("span", [_vm._v("Client Number*")])
              : _vm._e(),
            _vm._v(" "),
            _vm.allocateResult.length == 0
              ? _c("input", {
                  staticClass: "filter-item-content",
                  attrs: { type: "text", placeholder: "CLI-12345678" },
                  on: {
                    input: function (event) {
                      return (_vm.clientNumber = event.target.value)
                    },
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.confirmAllocation()
                    },
                  },
                })
              : _c("div", [
                  _vm.allocateResult[0].status == 200
                    ? _c("div", { staticClass: "success" }, [
                        _c("span", [_vm._v("VIBAN allocated successfully")]),
                        _vm._v(" "),
                        _c("div", [
                          _c("span", [_vm._v("Client Number:")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.allocateResult[0].Reference1)),
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v("VIBAN:")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.allocateResult[0].VIBAN)),
                          ]),
                        ]),
                      ])
                    : _c("div", { staticClass: "error" }, [
                        _c("span", [_vm._v("Client already has VIBAN")]),
                        _vm._v(" "),
                        _c("div", [
                          _c("span", [_vm._v("Client Number:")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.allocateResult[0].Reference1)),
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v("VIBAN:")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.allocateResult[0].VIBAN)),
                          ]),
                        ]),
                      ]),
                ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-content-buttons" }, [
              _vm.allocateResult.length == 0
                ? _c(
                    "button",
                    {
                      staticClass: "btn-outline-light btn",
                      on: {
                        click: function ($event) {
                          return _vm.closeModal()
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.allocateResult.length == 0
                ? _c(
                    "button",
                    {
                      staticClass: "btn-outline btn-dark",
                      class: {
                        inactive:
                          _vm.clientNumber == null || _vm.clientNumber == "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.confirmAllocation()
                        },
                      },
                    },
                    [_vm._v("Allocate")]
                  )
                : _c(
                    "button",
                    {
                      staticClass: "btn-outline btn-dark",
                      on: {
                        click: function ($event) {
                          return _vm.closeModal()
                        },
                      },
                    },
                    [_vm._v("Close")]
                  ),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }